import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  ten_dong_ho: undefined, // required, minLength: 1 - Tên dòng họ
  quoc_gia_id: undefined, // optional, ref: quoc_gia - Mã quốc gia
  tinh_id: undefined, // optional, ref: province - Mã tỉnh
  huyen_id: undefined, // optional, ref: district - Mã huyện
  xa_id: undefined, // optional, ref: commune - Mã xã
  dia_chi: undefined, // optional - Địa chỉ chi tiết
  // optional - Khoảng đinh (độ lớn của một dòng họ - là số lượng con trai)
  khoang_dinh: {
    tu: undefined, // optional, gt: 0 - Từ
    den: undefined, // optional, gt: 0 - Đến
  },
  xung_ho: undefined, // optional, enum(ong, ba, co, chu, anh, chi) - Xưng hô
  ho_ten: undefined, // required - Họ và tên đẩy đủ
  trong_ho: undefined, // optional - Node này có phải là người trong họ không hay là dâu/rể
  dien_thoai: undefined, // required, pattern: /^84\d{9}$/ - Số điện thoại
  email: undefined, // required, pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/ - Email
  ma_gioi_thieu: undefined,
  trang_thai: undefined, // required, enum(da_duyet, tu_choi, dang_xu_ly, dang_cho) - Trạng thái đăng ký
  li_do_tu_choi: undefined, // optional - Nêu lý do nếu thông tin đăng ký bị từ chối
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  thoi_diem_cap_nhat: undefined, // optional - Thời điểm cập nhật
  dong_ho_id: undefined, // optional - Id của dòng họ sau khi thông tin này được xác nhận và được tạo trên hệ thống
  thoi_diem_xet_duyet: undefined, // optional - Thời điểm thông tin này được xét duyệt/từ chối
  nguoi_xet_duyet: undefined, // optional, ref: mushroom_user - Mã người xét duyệt/từ chối đăng ký
};

// validation form
model.validForm = {
  ho_ten: [ValidService.required],
  email: [ValidService.required, ValidService.checkSpaceString, ValidService.checkEmail],
  xung_ho: [ValidService.required],
  ten_dong_ho: [ValidService.required],
  ten_quoc_gia: [ValidService.required],
  dia_chi: [ValidService.required],
  li_do_tu_choi: [ValidService.required],
  "khoang_dinh.tu": [ValidService.required],
  "khoang_dinh.den": [ValidService.required],
  ma_gioi_thieu: [{
    pattern: /^GT\d{6}$/,
    message: 'Mã giới thiệu có định dạng là GT + 6 chữ số',
    trigger: "blur",
  }]
};
model.khoangDinh = [
  {
    value: 1,
    label: "Dưới 100 đinh",
  },
  {
    value: 100,
    label: "Từ 100 đến 200 đinh",
  },
  {
    value: 200,
    label: "Từ 200 đến 300 đinh",
  },
  {
    value: 300,
    label: "Từ 300 đến 500 đinh",
  },
  {
    value: 500,
    label: "Từ 500 đến 1000 đinh",
  },
  {
    value: 1000,
    label: "Từ 1000 đến 3000 đinh",
  },
  {
    value: 3000,
    label: "Trên 3000 đinh",
  },
];
model.xungHo = [
  {
    value: "ong",
    label: "Ông",
  },
  {
    value: "ba",
    label: "Bà",
  },
  {
    value: "co",
    label: "Cô",
  },
  {
    value: "chu",
    label: "Chú",
  },
  {
    value: "anh",
    label: "Anh",
  },
  {
    value: "chi",
    label: "Chị",
  },
];

model.trangThai = [
  {
    value: "da_duyet",
    label: "Đã duyệt",
  },
  {
    value: "dang_cho",
    label: "Chờ duyệt",
  },
  {
    value: "tu_choi",
    label: "Từ chối",
  },
  {
    value: "",
    label: "Tất cả",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "trang_thai:in:dang_cho,dang_xu_ly",
  recordSelected: [],

  dataSearch: {
    value: {
      ten_dong_ho: "",
      ho_ten: "",
      dien_thoai: "",
      email: "",
      thoi_diem_tao: "",
      trang_thai: ["dang_cho", "dang_xu_ly"],
    },
    valid: {
      ten_dong_ho: [],
      thoi_diem_tao: [],
    },
    operator: {
      ten_dong_ho: ":regex_i:",
      ho_ten: ":regex_i:",
      dien_thoai: ":regex_i:",
      email: ":regex_i:",
      thoi_diem_tao: ":in_that_day:",
      trang_thai: ":in:",
    },
  },
};

export default model;
